import { Spiner } from "@components/loaders/spiner";
import { AccountService } from "@services/account.service";
import { useStudentBio } from "@hooks/use_student_bio";
import { usePageHeader } from "@hooks/use_page_header";
import { useMutation, useQuery } from "@tanstack/react-query";
import { formatValue, toRp } from "@utils/helper";
import { Button, Form, Input, message } from "antd";
import { NoticeType } from "antd/es/message/interface";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const MarketplaceSettingPage = () => {
  const { state } = useLocation();
  usePageHeader("Atur Limit", { bottomNavigation: "hidden" });
  const [form] = Form.useForm();
  const [valLimitBelanja, setValLimitBelanja] = useState<string>("");
  const [valLimitEdc, setValLimitEdc] = useState<string>("");

  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const { nis } = useStudentBio();

  const { data, isPending, refetch } = useQuery({
    queryKey: [AccountService.queries.GET_SETTING_LIMIT, nis],
    queryFn: async () => AccountService.settingLimit(nis),
  });

  const { mutate: mutateUpdate, isPending: isPendingUpdate } = useMutation({
    mutationFn: AccountService.updateSettingLimit,
    onSuccess: (response) => {
      setShowMessage(true);
      setMessageType("success");
      setShowMessageText("Update limit berhasil");

      refetch();
    },
    onError: (error: any) => {
      setShowMessage(true);
      setMessageType("error");
      setShowMessageText(error.message ?? "Internal Error");
    },
  });


  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText, messageType, messageApi]);

  const onConfirmUpdate = () => {
    const values = form.getFieldsValue();
    mutateUpdate({
      nis: nis,
      limit_belanja: values.limit_belanja.replace(/\./g, ""),
      limitedc: values.limitedc.replace(/\./g, ""),
    });
  };

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        {isPending ? (
          <div className="tw-p-8 tw-text-center">
            <Spiner />
          </div>
        ) : (
          <Form
            form={form}
            className=""
            autoComplete="off"
            initialValues={{
              limit_belanja: formatValue(data?.data?.limit_belanja ?? "0"),
              limitedc: formatValue(data?.data?.limitedc ?? "0"),
            }}
            //   onFinish={(data) => onUpdateBio(data)}
          >
            <div className="tw-py-2 card-body">
              <Form.Item
                label="Limit Belanja (Rp.)"
                name="limit_belanja"
                className="tw-mb-1"
              >
                <Input
                  className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                  placeholder="Limit Belanja"
                  inputMode="numeric"
                  type="text"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    const formattedValue = formatValue(
                      value === "" ? "0" : value
                    );
                    form.setFieldsValue({ limit_belanja: formattedValue });
                    setValLimitBelanja(value === "" ? "0" : formattedValue);
                  }}
                  onKeyDown={(event) => {
                    if (!/[0-9]|Backspace|Tab/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={valLimitBelanja}
                />
              </Form.Item>
              <div className="tw-mb-4 tw-text-xs tw-italic">
                Untuk membatasi Santri berbelanja di Toko{" "}
                <b>via Admin di Pondok</b>. adapun belanja oleh orang tua tidak
                dibatasi.
              </div>
              <Form.Item
                label="Limit Uang Saku (Rp.)"
                name="limitedc"
                className="tw-mb-1"
              >
                <Input
                  className=" hover:tw-border-primary tw-shadow-none focus:tw-shadow-none tw-text-base"
                  placeholder="Limit Uang Saku"
                  inputMode="numeric"
                  type="text"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    const formattedValue = formatValue(
                      value === "" ? "0" : value
                    );
                    form.setFieldsValue({ limitedc: formattedValue });
                    setValLimitEdc(value === "" ? "0" : formattedValue);
                  }}
                  onKeyDown={(event) => {
                    if (!/[0-9]|Backspace|Tab/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={valLimitEdc}
                />
              </Form.Item>
              <div className="tw-mb-4 tw-text-xs tw-italic">
                Untuk membatasi Santri mengambil <b>Uang Saku</b>
              </div>
              <Button
                type="primary"
                htmlType="submit"
                loading={isPendingUpdate}
                onClick={onConfirmUpdate}
                className="tw-p-2 tw-mt-4 tw-h-10 tw-w-full tw-text-sm tw-rounded-xl tw-border-0 tw-text-white focus:tw-shadow-none"
                style={{ background: "#166534" }}
              >
                {isPendingUpdate ? "" : "Update"}
              </Button>
            </div>
          </Form>
        )}
      </div>
    </>
  );
};

export default MarketplaceSettingPage;
